import * as React from 'react'
import { TemplatePreview } from './TidalPreview'
import { Theme } from '@mui/material/styles'

import Paper from '@mui/material/Paper'
import IconButton from '@mui/material/IconButton'
import VisibilityIcon from '@mui/icons-material/Visibility'
import Fade from '@mui/material/Fade'
import { useFormPacketsEnabled } from '@user/store/tenantFeatures/hooks/useFormPacketsEnabled'

const styles = {
  eyeIcon: {
    padding: (theme: Theme) => theme.spacing(0),
  },

  paper: {
    padding: (theme: Theme) => theme.spacing(1),
  },

  popover: {
    pointerEvents: 'none',
  },
}

interface Props {
  templateId: number
  color?:
    | 'inherit'
    | 'default'
    | 'primary'
    | 'secondary'
    | 'error'
    | 'info'
    | 'success'
    | 'warning'
}

export const TemplatePreviewPopover = (props: Props) => {
  const { templateId, color } = props
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null)
  const formPacketEnabled = useFormPacketsEnabled()

  const handlePopoverOpen = (
    event: React.MouseEvent<HTMLElement, MouseEvent>,
  ) => {
    setAnchorEl(event.currentTarget)
  }

  const handlePopoverClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)

  return (
    <>
      <IconButton
        color={color || 'primary'}
        aria-label="template-preview"
        sx={styles.eyeIcon}
        aria-owns={open ? 'template-preview-popover' : undefined}
        aria-haspopup="true"
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
        size="large"
        data-test-id="agreement-card-preview-button"
      >
        <VisibilityIcon fontSize="small" />
      </IconButton>
      {open && (
        <Fade in={open}>
          <Paper
            sx={{
              position: formPacketEnabled ? 'absolute' : 'fixed',
              top: formPacketEnabled ? 'unset' : 20,
              bottom: !formPacketEnabled ? 'unset' : 20,
              left: formPacketEnabled ? '100%' : '45%',
              zIndex: 100,
              backgroundColor: 'white',
              p: 1,
              pointerEvents: 'none',
            }}
          >
            <TemplatePreview templateId={templateId} />
          </Paper>
        </Fade>
      )}
    </>
  )
}

TemplatePreviewPopover.displayName = 'TemplatePreviewPopover'
